module.exports = __webpack_public_path__ + "static/media/bison-burger-mobile-fr.9cb5d61b.jpg";